// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'fast-forward';

export const Component = () => (
  <path d='m2.484 3.144 14.751 8.381c.288.24.431.527.431.814 0 .335-.143.575-.43.814L2.483 21.487c-.096.096-.287.143-.526.143a.946.946 0 0 1-.67-.287.946.946 0 0 1-.288-.67V3.958c0-.24.096-.48.288-.67A.946.946 0 0 1 1.958 3c.239 0 .431.048.526.144Zm-.527.814v16.715l14.75-8.334-14.75-8.381Zm6.418-.814 14.75 8.381c.288.24.432.527.432.814 0 .335-.144.575-.431.814L8.375 21.487c-.096.096-.287.143-.527.143a.946.946 0 0 1-.67-.287.946.946 0 0 1-.287-.67V3.958c0-.24.096-.48.287-.67A.946.946 0 0 1 7.848 3c.24 0 .432.048.527.144Zm-.527.814v16.715l14.75-8.334-14.75-8.381Z' />
);

export const viewBox = '0 0 25 25';
